import type { TableSettings, UserSettings } from '../user/UserSettings';
import type { FilterPreset } from './FilterPreset';

export type TablesSettingsResponseBody = UserSettings & {
  filters: FilterPreset[];
  userSettings: TableSettings;
};
